<div
  *ngIf="parentFormGroup?.controls[controlName]"
  class="font-work-sans font-regular {{screenType}}"
>
  <div
    *ngIf="label"
    class="form-field-label {{type}} flex flex-row justify-between"
  >
    <div class="label flex flex-row content-center">
      {{ label }}
      <span
        *ngIf="isRequired"
        class="required-mark ml-[0.3rem]"
      >*</span>
      <app-icon
        *ngIf="tooltipText"
        [matTooltip]="tooltipText"
        class="tooltip-icon"
        matTooltipClass="custom-tooltip"
        matTooltipPosition="below"
        svgIcon="info"
      ></app-icon>
    </div>
  </div>
  <mat-form-field
    [formGroup]="parentFormGroup"
    [ngClass]="type ? 'small' : ''"
    appearance="outline"
    class="form-field w-full"
    hideRequiredMarker
  >
    <mat-icon
      *ngIf="prefixIcon"
      [svgIcon]="prefixIcon"
      class="cursor-pointer"
      matPrefix
    ></mat-icon>
    <mat-icon
      *ngIf="suffixIcon"
      [svgIcon]="suffixIcon"
      class="cursor-pointer"
      matSuffix
      (click)="suffixClick()"
    ></mat-icon>
    <input
      #input
      [appInputRestriction]="inputRestriction"
      [parentFormGroup]="parentFormGroup"
      [controlName]="controlName"
      [formControlName]="controlName"
      [maxlength]="maxLength"
      [minlength]="minLength"
      [readonly]="readonly"
      (keyup.enter)="suffixClick()"
      class="input {{type}} text-input"
      matInput
      placeholder="{{placeholder}}"
      type="text"
    >
    <mat-error *ngIf="error">{{ error }}</mat-error>
    <div
      *ngIf="showCharCount"
      class="char-count flex w-full justify-end"
    >
      {{ parentFormGroup?.controls[controlName]?.value?.length }}/{{ maxLength }}
    </div>
  </mat-form-field>
</div>
